import { render, staticRenderFns } from "./HubToRtmCreate.vue?vue&type=template&id=99c10d12&"
import script from "./HubToRtmCreate.vue?vue&type=script&lang=js&"
export * from "./HubToRtmCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports